<template>
  <oxd-table-filter :filter-title="$t('payroll.payroll_runs')">
  </oxd-table-filter>
  <br />
  <div class="orangehrm-paper-container">
    <div class="orangehrm-header-container">
      <div>
        <oxd-button
          :label="$t('general.add')"
          icon-name="plus"
          display-type="secondary"
          @click="onClickAdd"
        />
      </div>
    </div>
    <table-header :total="total" :loading="isLoading"></table-header>
    <div class="orangehrm-container">
      <oxd-card-table
        :headers="headers"
        :items="items?.data"
        :selectable="false"
        :clickable="true"
        :loading="isLoading"
        row-decorator="oxd-table-decorator-card"
        @click="onClickRow"
      />
    </div>
    <div class="orangehrm-bottom-container">
      <oxd-pagination
        v-if="showPaginator"
        v-model:current="currentPage"
        :length="pages"
      />
    </div>
  </div>
</template>

<script>
import {navigate} from '@/core/util/helper/navigation';
import {APIService} from '@/core/util/services/api.service';
import usePaginate from '@ohrm/core/util/composable/usePaginate';

export default {
  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/payroll/runs',
    );

    const payrollRunNormalizer = (data) => {
      return data.map((item) => {
        return {
          id: item.id,
          name: item.name,
          timePeriod: `${item.periodStartDate} - ${item.periodEndDate}`,
          payPeriod: item.payPeriod.name,
          payDate: item.payDate,
          status: item.status,
          totalEmployees: item.totalEmployees,
          totalGrossAmount: item.totalGrossAmount.toLocaleString(),
          totalDeductions: item.totalDeductions.toLocaleString(),
          totalNetAmount: item.totalDeductions.toLocaleString(),
        };
      });
    };

    const {
      total,
      pages,
      response,
      isLoading,
      execQuery,
      currentPage,
      showPaginator,
    } = usePaginate(http, {
      normalizer: payrollRunNormalizer,
    });

    return {
      http,
      total,
      pages,
      isLoading,
      execQuery,
      currentPage,
      showPaginator,
      items: response,
    };
  },

  data() {
    return {
      headers: [
        {
          name: 'name',
          slot: 'title',
          title: this.$t('general.name'),
          style: {flex: 1},
        },
        {
          name: 'payPeriod',
          title: this.$t('payroll.pay_period'),
          style: {flex: 1},
        },
        {
          name: 'timePeriod',
          title: this.$t('payroll.time_period'),
          style: {flex: 1},
        },
        {
          name: 'payDate',
          title: this.$t('payroll.pay_date'),
          style: {flex: 1},
        },
        {
          name: 'totalEmployees',
          title: this.$t('payroll.total_employees'),
          style: {flex: 1},
        },
        {
          name: 'status',
          title: this.$t('general.status'),
          style: {flex: 1, 'text-transform': 'capitalize'},
        },
      ],
    };
  },

  methods: {
    onClickAdd() {
      navigate('/payroll/addPayrollRuns');
    },
    onClickRow(row) {
      const id = row?.id ?? row?.item?.id;
      if (id) {
        navigate(`/payroll/viewPayrollPayslips/${id}`);
      }
    },
  },
};
</script>
